<template>
  <hr>
  <div id="aseguradoras" class="service-wrap pb-100 mt-5">
    <div class="container">
      <div class="row">
        <div class="col-xl-6 offset-xl-3 col-lg-8 offset-lg-2">
          <div class="section-title style1 text-center mb-40">
            <h2>Aseguradoras que nos avalan</h2>
          </div>
        </div>
      </div>

      <Carousel
        :autoplay="30000"
        :wrap-around="true"
        :breakpoints="breakpoints"
        pause-autoplay-on-hover
        class="service-slider-three"
      >
        <Slide v-for="service in services" :key="service.id">
          <div class="service-card style5">
            <div class="service-info-wrap">
              <div class="service-info">
                <h3>
                  <router-link to="/service-details">
                    {{ service.title }}
                  </router-link>
                </h3>
              </div>
            </div>
            <div class="service-img col-12">
              <img :src="service.image" alt="Image" width="250px"/>
            </div>
          </div>
        </Slide>
      </Carousel>
      <div class="col-12 text-center hero-btn">
        <a href="#contacto" class="col-6 mt-5 btn style2">Únete a las empresas que priorizan la salud visual de sus empleados.</a>    
      </div>
    </div>
  </div>
</template>

<script>
import { defineComponent } from "vue";
import { Carousel, Slide, Pagination } from "vue3-carousel";

export default defineComponent({
  name: "BestServices",
  components: {
    Carousel,
    Slide,
  },
  data: () => ({
    settings: {
      itemsToShow: 1,
      snapAlign: "center",
    },
    services: [
  {
    id: 1,
    title: "AXA",
    image: require("../../assets/images/aseguradoras/axa.png"),
  },
  {
    id: 2,
    title: "Banjericto",
    image: require("../../assets/images/aseguradoras/banjercito.png"),
  },
  {
    id: 3,
    title: "Bupa",
    image: require("../../assets/images/aseguradoras/bupa.png"),
  },
  {
    id: 4,
    title: "BX+",
    image: require("../../assets/images/aseguradoras/bx+.png"),
  },
  {
    id: 5,
    title: "ChoiceNet",
    image: require("../../assets/images/aseguradoras/choicenet.jpg"),
  },
  {
    id: 6,
    title: "Dentegra",
    image: require("../../assets/images/aseguradoras/dentegra.png"),
  },
  {
    id: 7,
    title: "GNP",
    image: require("../../assets/images/aseguradoras/gnp.jpeg"),
  },
  {
    id: 8,
    title: "HSBC",
    image: require("../../assets/images/aseguradoras/hsbc.jpg"),
  },
  {
    id: 9,
    title: "IKE",
    image: require("../../assets/images/aseguradoras/ike.jpg"),
  },
  {
    id: 10,
    title: "Inbursa",
    image: require("../../assets/images/aseguradoras/inbursa.png"),
  },
  {
    id: 11,
    title: "Latino",
    image: require("../../assets/images/aseguradoras/latino.png"),
  },
  {
    id: 12,
    title: "MediAccess",
    image: require("../../assets/images/aseguradoras/mediaccess.png"),
  },
  {
    id: 13,
    title: "Mapfre",
    image: require("../../assets/images/aseguradoras/mapfre.png"),
  },
  {
    id: 14,
    title: "Monterrey",
    image: require("../../assets/images/aseguradoras/monterrey.png"),
  },
  {
    id: 15,
    title: "Oceas",
    image: require("../../assets/images/aseguradoras/oceas.png"),
  },
  {
    id: 16,
    title: "Plan Seguro",
    image: require("../../assets/images/aseguradoras/planSeguro.png"),
  },
  {
    id: 17,
    title: "Prevem",
    image: require("../../assets/images/aseguradoras/prevem.png"),
  },
  {
    id: 18,
    title: "Santander",
    image: require("../../assets/images/aseguradoras/santander.png"),
  },
  {
    id: 19,
    title: "SISNova",
    image: require("../../assets/images/aseguradoras/sisnova.jpg"),
  },
  {
    id: 20,
    title: "Zurich",
    image: require("../../assets/images/aseguradoras/zurich.png"),
  },
],
    breakpoints: {
      0: {
        itemsToShow: 1,
        snapAlign: "center",
      },
      768: {
        itemsToShow: 2,
        snapAlign: "start",
      },
      1200: {
        itemsToShow: 3,
        snapAlign: "center",
      },
    },
  }),
});
</script>